import { OXE_DISCONNECTION } from "../../utils/Constants"
import store from "../../store/store"
import { handleOXEDisconnection } from "../../store/actions/OxeActions"
import { getSessionItem } from "../../utils/storageUtils"
import { TOKEN_2 } from "../../utils/Constants"

/** Get data from Sip Trunk backend (BF 5/12/2024)
 * @param {String} url Endpoint url
 * @param {String} headerSection  Header of the request
 * @param {String} dataHandler Data handler to manage the response if no error
 * @returns {React.ReactNode} Returns request response
*/
const getData = async (url, headerSection, dataHandler) => {

    var response;

    try {
        if (!headerSection) {
            headerSection = { headers: { "Authorization": `Bearer ${getSessionItem(TOKEN_2)}` } };
        }
        response = await fetch(url, headerSection);
        if (response.ok) {
            let list = await response.json();
            if (list.data !== undefined) {
                // Backend error handling
                dataHandler(list.data);
            }
        } else if (response.status === 401) {
            const data = await response.json()
            if (data.errorCode === OXE_DISCONNECTION) {
                store.dispatch(handleOXEDisconnection());
            }
            else
                window.location = "/logout"
        }
    }
    catch (e) {
        console.error(e);
    }
    return response;
};

export default getData;